import React, { useReducer } from "react";

import {
  Grid,
  Typography,
  makeStyles,
  useTheme,
  Box,
  Button,
} from "@material-ui/core";
import AddUpdateCompany from "./AddUpdateCompany";
import AddUpdateContacts from "./AddUpdateContacts";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-root": {
      marginTop: theme.spacing(2),
    },
    "& .MuiButton-endIcon": {
      display: "inherit",
      marginLeft: 8,
      marginRight: -4,
    },
    "& .MuiPaper-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDivider-root": {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
}));

function reducer(state, action) {
  switch (action.type) {
    case "name":
      return { ...state, name: action.value };
    case "address":
      return { ...state, address: action.value };
    case "cities":
      return { ...state, cities: action.value };
    case "signal":
      return { ...state, is_signal: action.value };
    case "contact": //This action is for adding new contact to the array of contacts
      //if state contains id greater then 1, we are in update
      const {
        id,
        contact_first_name,
        contact_last_name,
        contact_email,
        contact_mobile,
        contact_role,
        is_primary,
      } = action.value;
      const contactDetails = {
        id: id,
        contact_first_name: contact_first_name,
        contact_last_name: contact_last_name,
        contact_email: contact_email,
        contact_mobile: contact_mobile,
        contact_role: contact_role,
        is_primary: is_primary,
      };
      if (id >= 1) {
        //need to update the contact with this id:
        const tempContacts = state.contacts;
        const contIndex = tempContacts.findIndex((cont) => cont.id === id);

        if (contIndex > -1) {
          tempContacts[contIndex] = contactDetails;
          return {
            ...state,
            contacts: tempContacts,
          };
        }
      }
      return {
        ...state,
        contacts: [...state.contacts, contactDetails],
      };
    case "removeContact": {
      const tempContacts = state.contacts;
      const contactRemoveIndex = state.contacts.find(
        (cont) => cont.id === action.value
      );
      if (contactRemoveIndex) {
        tempContacts.splice(contactRemoveIndex, 1);
      }
      return {
        ...state,
        contacts: tempContacts,
      };
    }
    case "contacts":
      return { ...state, contacts: action.value };
    case "company": {
      return action.value;
    }
    default:
      return state;
  }
}

const AddUpdateCompanyManager = ({
  company,
  onAddCompany,
  onClose,
  sigalCategories,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [state, dispatch] = useReducer(reducer, {
    id: -1,
    name: "",
    address: "",
    is_signal: false,
    signals: [],
    cities: [],
    contacts: [],
    logo: "",
  });
  const [fieldsUpdated, setFieldsUpdated] = React.useState([]);

  React.useEffect(() => {
    if (company) dispatch({ type: "company", value: company });
  }, [company]);

  const handleUpdateComapny = (type, value) => {
    dispatch({ type: type, value: value });
    setFieldsUpdated((previous) =>
      !previous.includes(type) ? [...previous, type] : previous
    );
  };

  const handleAddCompany = () => {
    onAddCompany(
      {
        id: company ? company.id : false,
        name: state.name,
        address: state.address,
        signal: state.is_signal,
        signals: [],
        contacts: state.contacts,
        cities: state.cities,
        logo: state.logo,
      },
      fieldsUpdated
    );
  };

  return (
    <React.Fragment>
      <Box my={4} className={classes.root} maxWidth={1200} mx="auto">
        <Grid container spacing={2}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <Box my={4}>
              <Typography variant="h4" color="textPrimary" paragraph>
                {company ? `Update Company ${company.name}` : "Add New Company"}
              </Typography>
              <AddUpdateCompany
                onUpdate={handleUpdateComapny}
                singalCategoes={sigalCategories}
                company={state}
              />
              <Box my={4}>
                <AddUpdateContacts
                  contacts={state ? state.contacts : null}
                  onUpdate={handleUpdateComapny}
                />
              </Box>
            </Box>
            <Box my={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddCompany}
              >
                {company ? "Update Company" : "Add Comapny"}
              </Button>

              <Button
                color="primary"
                onClick={onClose}
                style={{ marginLeft: theme.spacing(1) }}
              >
                Cancel
              </Button>
            </Box>
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
};
export default AddUpdateCompanyManager;
